import React from 'react';
import './Container.scss';

const Container = React.forwardRef((props, ref) => {
  const { fluid, direction, align, base, className, style } = props;
  return (
    <div
      className={[
        'container',
        fluid ? 'container-fluid' : '',
        direction ? `container-${direction}` : '',
        align ? `container-align-${align}` : '',
        base ? `container-base-${base}` : '',
        className
      ].join(' ')}
      style={style}
      ref={ref}
    >
      {props.children}
    </div>
  );
});

export default Container;
